import { AdvancedRegentsAssignmentAugCtrl } from './advanced-regents-assignment-aug.controller';

export const AdvancedRegentsAssignmentAugComponent = {
  controller: AdvancedRegentsAssignmentAugCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./advanced-regents-assignment-aug.html'),
};
